import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiHeart, FiHome, FiShoppingCart, FiBookOpen, FiDollarSign, FiTruck, FiGrid, FiArrowRight } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import industriesHero from "../assets/industries-hero.jpg";

const industries = [
  { icon: FiHeart, title: "Healthcare & Hospitals", desc: "HIPAA-compliant solutions, patient management systems, telemedicine platforms, and healthcare analytics." },
  { icon: FiHome, title: "Real Estate & Construction", desc: "Property listing platforms, CRM solutions, virtual tours, and construction project management tools." },
  { icon: FiShoppingCart, title: "E-Commerce & Retail", desc: "Online stores, inventory management, payment gateways, and omnichannel marketing solutions." },
  { icon: FiBookOpen, title: "Education & E-Learning", desc: "LMS platforms, virtual classrooms, student portals, and educational content management." },
  { icon: FiDollarSign, title: "Finance & FinTech", desc: "Banking apps, payment processing, financial analytics, and regulatory compliance systems." },
  { icon: FiTruck, title: "Logistics & Transportation", desc: "Fleet management, route optimization, warehouse management, and real-time tracking." },
  { icon: FiGrid, title: "Government & Enterprises", desc: "Digital transformation, e-governance platforms, and enterprise resource management." },
];

const Industries = () => {
  return (
    <>
      <HeroBanner
        image={industriesHero}
        title="Industries We Serve"
        subtitle="Industry-specific solutions aligned with compliance, scalability, and performance benchmarks."
      />

      <SectionWrapper>
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">Serving <span className="text-primary">Multiple Industries</span></h2>
          <p className="section-subtitle mx-auto">
            We build industry-specific solutions aligned with compliance, scalability, and performance benchmarks.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((ind, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="card-hover group"
            >
              <ind.icon className="w-12 h-12 text-primary mb-4 group-hover:scale-110 transition-transform" />
              <h3 className="font-montserrat font-bold text-xl mb-3">{ind.title}</h3>
              <p className="text-muted-foreground font-roboto text-sm leading-relaxed">{ind.desc}</p>
            </motion.div>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Don't See Your Industry?</h2>
        <p className="text-primary-foreground/80 font-roboto text-lg mb-8 max-w-2xl mx-auto">
          We build custom solutions for any industry. Let's discuss your specific needs.
        </p>
        <Link to="/contact" className="btn-hero-outline">Contact Us</Link>
      </SectionWrapper>
    </>
  );
};

export default Industries;
